<template>
  <div>
    <div class="demo-drawer__content data_action_form">
      <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
        <v-tabs :type="99" :activeName="'外部订单明细'" :name="'jciName'" :value="'jciName'" :tabslist="tabForm"
          @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
          <template slot="tabs" slot-scope="scope">
            <div v-if="scope.index == 0">
              <el-table class="table1" stripe :data="returnData.list" :height="mxHeight" border style="width: 100%"
                highlight-current-row size="mini">
                <el-table-column v-for="(tableValye, tableKey) in returnData.name" :key="tableKey" show-overflow-tooltip
                  :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                  <template slot-scope="scope">
                    <span v-if="tableValye.fieldType == 'date'">
                      <span v-if="scope.row[tableValye.entityField]">
                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                      </span>
                    </span>
                    <el-input :disabled="actionData.cate == 2 || actionData.orderState == -1"
                      @input="calculatePrice(5, scope.$index)" v-else-if="tableValye.entityField == 'orderNum'"
                      v-model="returnData.list[scope.$index].orderNum">
                    </el-input>
                    <span v-else>
                      {{ scope.row[tableValye.entityField] }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button @click="delMX(scope.row, scope.$index)" type="danger" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </v-tabs>
      </el-card>

      <div class="foot">
        <div style="text-align: center;">
          <el-button type="primary" @click="initActionBox()">取消</el-button>
          <el-button type="primary" @click="saveAction()">保存</el-button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
export default {
  name: "orderpoolQueryDetail",
  props: ["actionData"],
  data() {
    //这里存放数据
    return {
      returnData: {
        list: [],
        name: [
          {
            chineseField: "商品编码",
            entityField: "bgmCode",
            showField: "商品编码",
            fieldWeight: 150,
          },
          {
            chineseField: "通用名称",
            entityField: "bgmName",
            showField: "通用名称",
            fieldWeight: 120,
          }, {
            chineseField: "规格",
            entityField: "spec",
            showField: "规格",
            fieldWeight: 120,
          }, {
            chineseField: "生产厂商",
            entityField: "manufacturer",
            showField: "生产厂商",
            fieldWeight: 120,
          }, {
            chineseField: "可销数量",
            entityField: "stockNum",
            showField: "可销数量",
            fieldWeight: 120,
          }, {
            chineseField: "订单数量",
            entityField: "orderNum",
            showField: "订单数量",
            fieldWeight: 120,
          }, {
            chineseField: "含税价格",
            entityField: "psprice",
            showField: "含税价格",
            fieldWeight: 120,
          }, {
            chineseField: "含税金额",
            entityField: "psmoney",
            showField: "含税金额",
            fieldWeight: 120,
          }, {
            chineseField: "批号",
            entityField: "batchno",
            showField: "批号",
            fieldWeight: 120,
          }, {
            chineseField: "生产日期",
            entityField: "prodate",
            showField: "生产日期",
            fieldWeight: 120,
            fieldType: "string",
          }, {
            chineseField: "有效期",
            entityField: "expidate",
            showField: "有效期",
            fieldWeight: 120,
            fieldType: "string",
          }, {
            chineseField: "UDI码",
            entityField: "unitCode",
            showField: "UDI码",
            fieldWeight: 120,
            fieldType: "string",
          }, {
            chineseField: "注册证号",
            entityField: "bgiRegistno",
            showField: "注册证号",
            fieldWeight: 120,
            fieldType: "string",
          },
          {
            chineseField: "含税成本价",
            entityField: "costPsprice",
            showField: "含税成本价",
            fieldWeight: 120,
            fieldType: "string",
          },

        ],
      },
      tabForm: [
        {
          jciName: "外部订单明细",
          jurconfigform: [],
        }
      ],
      mxHeight: 0
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.orderDetail()
    console.log(this.actionData)
  },
  //方法集合
  methods: {
    async orderDetail() {
      const responseData = await this.$http.orderpoolQueryDetail({
        ids: [this.actionData.orderId],
      });
      this.returnData.list = responseData.result
      this.$nextTick(() => {
        setTimeout(() => {
          this.mxHeight = this.$common.getBtnHeight()
        }, 16.7)
      })

    },
    //取消
    initActionBox() {
      this.$emit("drawerCancel");
    },
    saveAction() {//保存
      if (this.returnData.list.length == 0) {
        this.$message({
          message: "明细不能为空",
          type: "warning",
        });
        return
      } else {
        let data = {
          poolId: this.actionData.oldData.poolId,
          detailList: this.returnData.list
        }
        this.$http.orderpoolUpdateNumAdd(data).then(responseData => {
          if (responseData.status == 200) {

            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$emit("drawerCancel");
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        })
      }

    },
    async delMX(row, index) {
      const res = await this.$http.orderpooldeleteMx({ ids: [row.pooldetailId] })
      if (res.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.returnData.list.splice(index, 1)
        if (this.returnData.list.length == 0) {
          this.$emit("drawerCancel");
        }
      } else {
        this.$message({
          message: res.message,
          type: "error",
        });

      }
    },
    calculatePrice(cate, index) {
      var info = this.returnData.list[index]
      if (info.orderNum <= 0) {
        this.$message({
          message: "请先填写订单数量",
          type: "error",
        });
        return false;
      }
      // 通过数量计算
      //计算零散数量
      // this.returnData.list[index].scatNum = info.psodPacknum - info.wholeNum * Number(info.packingSpec)
      // 计算含税金额 含税价格*数量
      var midmoney = info.psodPacknum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.orderNum));
      // var midmoney = info.psodPacknum === 0 ? 0 : NP.times(info.psprice, info.psodPacknum).toFixed(10);
      this.returnData.list[index].psmoney = this.$common.getDecimalInfo(3, midmoney);
      // 计算总金额 含税金额/(税率/100+1)
      // this.returnData.list[index].money = this.$common.getDecimalInfo(3, NP.divide(this.returnData.list[index].psmoney, NP.plus(NP.divide(info.inRate, 100), 1)));
      // 计算整件数量
      //  this.returnData.list[index].wholeNum = Math.floor(NP.divide(info.orderNum, Number(info.packingSpec)));
      //计算零散数量
      // this.returnData.list[index].scatNum = NP.minus(info.orderNum, NP.times(this.returnData.list[index].wholeNum, Number(info.packingSpec)));
      //计算税额
      //this.returnData.list[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(this.returnData.list[index].psmoney, this.returnData.list[index].money));

      // // 计算件数 采数/包装单位
      // if (parseFloat(info.packingSpec) <= 0 || info.packingSpec == "") {
      //   this.returnData.list[index].pieceNum = 0;
      // } else {
      //   this.returnData.list[index].pieceNum =
      //     this.$common.getDecimalInfo(
      //       1,
      //       NP.divide(info.psodPacknum, info.packingSpec)
      //     );
      // }
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='css' scoped></style>
